import React, {Component} from 'react';

import Left from './Left';
import Middle from './Middle';
import Right from './Right';
import Bottom from './Bottom';
import './marketplace.css';
import $ from 'jquery';
import {isMobile} from 'react-device-detect';

class Marketplace extends Component {
  constructor(){
    super()
    this.state = {view:'marketpicker'};
  }
  setView(view) {
    this.setState({ view });
  }
  renderMobile(){
    let mnemStyle = this.state.view === "marketpicker" ? { color: "white",margin:'10px' } : { color: "grey",margin:'10px'};
    let jsonStyle = this.state.view === "orderbook" ? { color: "white",margin:'10px' } : { color: "grey",margin:'10px' };
    let privStyle = this.state.view === "placeorder" ? { color: "white",margin:'10px' } : { color: "grey",margin:'10px'};
    let myStyle = this.state.view === "myorders" ? { color: "white",margin:'10px' } : { color: "grey",margin:'10px'};


    return (
      <div className='minWidth container row'>
      <div clasName='col s12' style={{height:'70px',paddingTop:'10px',marginBottom:'10px'}}>
        <div className="col s3">
          <div onClick={this.setView.bind(this, "marketpicker")} className='B' style={{cursor:'pointer',border:this.state.view === "marketpicker" ? '1px solid white':'1px solid grey'}}>
            <h5 style={mnemStyle}> market picker </h5>
          </div>
        </div>
        <div className="col s3">
          <div onClick={this.setView.bind(this, "orderbook")} className='C' style={{cursor:'pointer',border:this.state.view === "orderbook" ? '1px solid white':'1px solid grey'}}>
            <h5 style={jsonStyle}> order book </h5>
          </div>
        </div>
        <div className="col s3">
          <div onClick={this.setView.bind(this, "placeorder")} className='D' style={{cursor:'pointer',border:this.state.view === "placeorder" ? '1px solid white':'1px solid grey'}}>
            <h5 style={privStyle}> place order </h5>
          </div>
        </div>
        <div className="col s3">
          <div onClick={this.setView.bind(this, "myorders")} className='D' style={{cursor:'pointer',border:this.state.view === "myorders" ? '1px solid white':'1px solid grey'}}>
            <h5 style={myStyle}> my orders</h5>
          </div>
        </div>
      </div>
      </div>
    )
  }
  render() {
    return (
      <>
      {isMobile && this.renderMobile()}
      <div className='minWidth container row marketplace' style={{paddingBottom:'10px'}}>
        {(isMobile && this.state.view === 'orderbook') || !isMobile ? <Left/> : null}
        {(isMobile && this.state.view === 'placeorder') || !isMobile ? <Middle/> : null}
        {(isMobile && this.state.view === 'marketpicker') || !isMobile ? <Right/> : null}
        {(isMobile && this.state.view === 'myorders') || !isMobile ? <Bottom/> : null}
      </div>
      </>
    );
  }
  componentDidMount(){
    setInterval(()=>{
      $('body').css('overflow','scroll')
    },5000)
  }
}

export default Marketplace
